import React from 'react';

export const Eye = ({ className }) => {
  return (
    <svg width="298" height="299" viewBox="0 0 298 299" fill="none" className={className}>
      <circle cx="149" cy="149.468" r="149" fill="white" />
      <circle r="116" transform="matrix(-1 0 0 1 148 149.468)" fill="#EBF8FF" stroke="#2A4365" strokeWidth="8" />
      <circle cx="149" cy="149.468" r="63" fill="#2A4365" />
      <circle cx="149" cy="149.468" r="55" fill="white" />
      <circle cx="149" cy="149.468" r="30" fill="#BEE3F8" />
      <circle cx="149" cy="149.468" r="15" fill="#2A4365" />
    </svg>
  );
};
